var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"text-center"},[_c('h1',{staticClass:"text-h4 mb-4"},[_vm._v("Carregando canais")]),_c('v-progress-circular',{attrs:{"indeterminate":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }